module.exports = __webpack_public_path__ + "img/car.8e7af3ba.webp";